export default {
	methods: {
		mutateService(service) {
			let vm = this

			service.customerName = ""
			if ("Customer" in service && service.Customer)
				service.customerName = service.Customer.name

			service.categoryName = "[uncategorized]"
			if ("Category" in service && service.Category)
				service.categoryName = service.Category.name

			//assign Gross Revenue
			let serviceRevenue = 0
			if ("ServiceInvoice" in service && service.ServiceInvoice.length > 0) {
				//find the invoice, not the quote
				let invoice = service.ServiceInvoice.find(inv => inv.is_quote == 0)

				if (invoice)
					serviceRevenue = parseFloat(invoice.pretax_total)
				else
					serviceRevenue = 0

				if ("totalRevenue" in vm && !isNaN(serviceRevenue))
					vm.totalRevenue += serviceRevenue
			}

			let materials = []
			try {
				materials = JSON.parse(service.parts_used_json)
			}
			catch (e) {}

			let equipment = []
			try {
				equipment = JSON.parse(service.equipment_used_json)
			}
			catch (e) {}

			if ("ServiceWorksheet" in service) {
				service.ServiceWorksheet.forEach(ws => {
					let wsMaterials = []
					try {
						wsMaterials = JSON.parse(ws.parts_used_json)
					}
					catch (e) {}

					let wsEquipment = []
					try {
						wsEquipment = JSON.parse(ws.equipment_used_json)
					}
					catch (e) {}

					materials = materials.concat(wsMaterials)
					equipment = equipment.concat(wsEquipment)
				})
			}

			let materialCost = +service.total_material_costs
			service.materialCostRaw = materialCost
			service.materialCost = materialCost.toCurrency()

			if ("totalMaterialCost" in vm)
				vm.totalMaterialCost += materialCost

			let equipmentCost = +service.total_equipment_costs
			service.equipmentCostRaw = equipmentCost
			service.equipmentCost = equipmentCost.toCurrency()

			if ("totalEquipmentCost" in vm)
				vm.totalEquipmentCost += equipmentCost

			let labourCost = +service.total_labour_costs
			service.labourCostRaw = labourCost
			service.labourCost = labourCost.toCurrency()

			if ("totalLabourCost" in vm)
				vm.totalLabourCost += labourCost

			let submittedExpenseCost = vm.calcServiceSubmittedExpenses(service)
			service.submittedExpenseCostRaw = submittedExpenseCost
			service.submittedExpenseCost = submittedExpenseCost.toCurrency()

			if ("totalSubmittedExpenses" in vm)
				vm.totalSubmittedExpenses += submittedExpenseCost

			let permitCost = 0
			if (service.permit_cost)
				permitCost = parseFloat(service.permit_cost)

			service.totalServiceTaskCostRaw = +service.total_service_task_costs

			service.permitCostRaw = permitCost
			service.permitCost = permitCost.toCurrency()

			if ("totalPermitsCost" in vm)
				vm.totalPermitsCost += permitCost

			service.completedDate = ""
			if (service.completed)
				service.completedDate = vm.formatDate(service.completed)

			service.revenueRaw = serviceRevenue
			service.revenue = serviceRevenue.toCurrency()

			let totalCosts = materialCost + labourCost + equipmentCost + permitCost
			service.totalCosts = totalCosts

			let grossProfit = serviceRevenue - totalCosts

			service.grossProfitRaw = grossProfit
			service.grossProfit = grossProfit.toCurrency()

			let taxCollected = 0
			if ("ServiceInvoice" in service && service.ServiceInvoice.length > 0)
				taxCollected = +service.ServiceInvoice[0].grand_total - +service.ServiceInvoice[0].pretax_total - +service.ServiceInvoice[0].untaxed_total
			
			service.taxCollectedRaw = taxCollected
			service.taxCollected = taxCollected.toCurrency()

			service.grossProfitMarginRaw = 0
			if (grossProfit != 0)
				service.grossProfitMarginRaw = grossProfit / serviceRevenue * 100

			service.grossProfitMargin = service.grossProfitMarginRaw.toFixed(1)+"%"

			return service
		},
		calcServiceSubmittedExpenses(service) {
			let vm = this

			if ("Expense" in service && service.Expense.length > 0) {
				return service.Expense.reduce((acc,exp) => {
					let cost = 0
					if (exp.cost)
						cost = parseFloat(exp.cost)
					let tip = 0
					if (exp.tip)
						tip = parseFloat(exp.tip)

					return acc+cost+tip
				},0)
			}
			return 0
		}
	}
}